import React, { useRef } from "react";
import {
  Button,
  Chip,
  Grid,
  FormControl,
  TextField,
} from "@material-ui/core";
import { MdClear } from "react-icons/md";
import { makeStyles } from "@material-ui/core/styles";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../common/InputField";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { searchIcon , crossImg} from "../../../resources/images";
import { FilterArrow } from "../../../ofishadmin/views/LeftNav/SvgIcons";

const ChipItem = ({ chipLabel, chipValue, onDelete }) => {
  const classes = useStyless();

  return (
    <Chip
      className={classes.MuiChip}
      deleteIcon={<MdClear style={{ width: "16px", height: "16px" }} />}
      label={
        <span className={classes.MuiChip}>
          <b>{chipLabel}: </b>
          {chipValue}
        </span>
      }
      onDelete={onDelete}
    />
  );
};

const useStyless = makeStyles((theme) => ({
  gridWrapper: {
    paddingTop: "29px",
    paddingBottom: "20px",
    borderBottom: "1px solid #E2E6E9",
    position: "relative",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  MuiChip: {
    backgroundColor: "#CDE5FF",
    color: "#70808F",
    maxWidth: "99%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    margin: "0px 5px 5px 0px",
  },
  chip: {
    margin: 2,
  },
  dropdownBg: {
    background: "#f1f1f1",
  },
  MuiSelect: {
    icon: {
      fontSize: "26px",
    },
    iconOutlined: {
      fontSize: "26px",
    },
  },
  MuiFilledInput: {
    root: {
      "&:hover": {
        backgroundColor: "#F3F6F9",
      },
    },
  },
  dropdownWrapper: {
    width: "650px",
    padding: "15px 37px 40px 37px",
    position: "fixed",
    boxShadow: "0px 0px 13px 0px #ccc",
    right: "95px",
    marginTop: "-55px",
  },
}));

const handleSubmit = (e) => {
  e.preventDefault();
};

function GridSearchFilter({
  filters,
  setPage,
  setRowsPerPage,
  setFilters,
  isFilterAdded,
  title,
  isFilter,
  showFilter,
  hideFilter,
  applyFilters,
  showFilterCounter,
  children,
}) {
  const classes = useStyless();

  return (
    <div className={classes.gridWrapper}>
      <ValidatorForm ref={useRef("form")} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid
            item
            md={12}
            className="filterMainSearch endUserSearchFilterMain"
          >
            <img src={searchIcon} alt="" className="searchIcon" />
            <InputField
              placeholder="Search"
              value={filters?.name }
              onKeyPress={({ key }) => {
                if (["Enter", "enter"].includes(key)) applyFilters();
              }}
              onChange={({ target }) => {
                setFilters({ ...filters, name: target.value });
              }}
              onPaste={(value) => {
                const splitValue = value.split("\n");
                setFilters({ ...filters, name: splitValue.join(", ") });
              }}
            />
            {
                isFilterAdded && <span className="endUserSearchFilter" onClick={showFilter}>
                    {showFilterCounter ? (
                        <span>{`${showFilterCounter} Filter${showFilterCounter > 1 ? "(s)" : ""
                            } Applied `}</span>
                    ) : null}
                    <FilterArrow color={"#fff"} />
                </span>
            }
          </Grid>
        </Grid>

        {isFilter && (
          <div className="endUserFilterWrapper">
            <div className="endUserFilterInnerWrapper">
              <img
                className="filterCrossImage"
                src={crossImg}
                alt="cross icon"
                onClick={hideFilter}
              />
              <div className="formContainer">
                <h3 className="endUserFilterHeading">
                  {title}
                </h3>
                {children}
              </div>
              <div className="endUserfilrerBtn">
                <Button
                  variant="contained"
                  onClick={() => {
                    setPage(1);
                    setRowsPerPage(10);
                    applyFilters();
                  }}
                >
                  Apply Filter
                </Button>
              </div>
            </div>
          </div>
        )}
      </ValidatorForm>
    </div>
  );
}

export default GridSearchFilter;


export const FilterAutoComplete = ({
  value,
  onChange,
  id,
  options,
  getOptionLabel,
  placeholder,
  selectedFilter,
  ...props
}) => {
  return <FormControl className='ac-dd'>
    <Autocomplete
      value={value}
      onChange={onChange}
      multiple
      filterSelectedOptions
      id={id}
      options={options}
      getOptionLabel={getOptionLabel}
      renderInput={params => (
        <TextField
          {...params} placeholder={placeholder} />
      )}
      {...props}
    />
    { selectedFilter > 0 && (
      <span className='countLabel'>{selectedFilter}</span>
    )}
  </FormControl>
}

export const AutoComplete = ({
  value,
  onChange,
  id,
  options,
  getOptionLabel,
  placeholder,
  ...props
}) => {
  return <FormControl className='ac-dd'>
    <Autocomplete
      value={value}
      onChange={onChange}
      id={id}
      options={options}
      getOptionLabel={getOptionLabel}
      renderInput={params => (
        <TextField
          {...params} placeholder={placeholder} />
      )}
      {...props}
    />
  </FormControl>
}

export const SelectedChiptItems = ({
  selectedItems,
  items,
  setFilters,
  filtersIndex,
  filtersLimit,
  showFilters,
  field,
  chipLabel,
}) => {
  return <>
    {selectedItems?.length > 0 &&
      selectedItems.map((id, index) => {
        filtersIndex = filtersIndex + 1;
        return (
          (filtersIndex <= filtersLimit || (filtersIndex > filtersLimit && showFilters)) && (
            <ChipItem
              key={id}
              chipLabel={chipLabel}
              chipValue={
                items?.find(x => x?.id === id)?.value
              }
              onDelete={() => {
                setFilters(prevFilters => ({
                  ...prevFilters,
                  [field]: prevFilters[field].filter(y => y !== id)
                }));
              }}
            />
          )
        );
      })
    }
  </>
}

export const SelectedDateChip = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  chipLabel,
}) => {
  return <>
    {(startDate || endDate) && (
      <ChipItem
        chipLabel={chipLabel}
        chipValue={`${startDate
            ? moment(startDate).format("MM/DD/yyyy")
            : "?"
          } - ${endDate ? moment(endDate).format("MM/DD/yyyy") : "?"
          }`}
        onDelete={() => {
          if (startDate) setStartDate(null);
          if (endDate) setEndDate(null);
        }}
      />
    )}
  </>
}
